import { defineStore } from "pinia";
import api from "@/_helpers/api";
import { axiosInstance } from "@/plugins/https";
import { StoreModule } from "@/constants/store.ts";

export interface DiscoveryServiceItem {
  deployment: string;
  serviceName: string;
  branchName: string;
  commitHash: string;
  artifact: string;
  buildName: string;
  buildVersion: string;
  buildTime: number;
  artifactGroup: string;
  error: string;
}

export interface DiscoveryServiceStatsState {
  services: DiscoveryServiceItem[];
  showSkeletonLoader: boolean;
}

const defaultWorkspaceCodesState: DiscoveryServiceStatsState = {
  services: [],
  showSkeletonLoader: false,
};

export const useDiscoveryStatsModule = defineStore(StoreModule.DISCOVERY_STATS, {
  state: () => ({ ...defaultWorkspaceCodesState }),
  actions: {
    async getServices(showSkeletonLoader: boolean = false) {
      this.showSkeletonLoader = showSkeletonLoader;
      const request = {
        ...api.discoveryServiceStats(),
        method: "GET",
      };
      try {
        const { data } = await axiosInstance.request(request);
        this.services = data;
        this.showSkeletonLoader = false;
      } catch (e) {
        console.error(e);
        this.showSkeletonLoader = false;
      }
    },
  },
});
